import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ColimindDebugService {
  readonly enabled = signal(false);

  private buffer: number[] = [];

  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'd') {
      this.buffer = [];
      return;
    }
    this.buffer.push(Date.now());
    this.buffer = this.buffer.filter(t => Date.now() - t < 1500);
    if (this.buffer.length >= 3) {
      this.enabled.update(v => !v);
      this.buffer = [];
    }
  }
}
